'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ScopeChangeInboxCtrl
 * @description
 * # ScopeChangeInboxCtrl
 * Bandeja de solicitudes de cambio de alcance pendientes de revision.
 */
angular.module('thothApp.controllers')
  .controller('ScopeChangeInboxCtrl', [
  '$scope', 'ScopeChangeRequest', 'ScopeChangeReview', 'toaster',
  function ($scope, ScopeChangeRequest, ScopeChangeReview, toaster) {
      $scope.loading = true;
      $scope.requests = [];
      $scope.reviewing = null;

      $scope.load = function() {
        $scope.loading = true;
        ScopeChangeRequest.index({ params: { status: 'pending', per_page: 'all' } }).then(function(response) {
          $scope.requests = response.data.scope_change_requests;
          $scope.loading = false;
        }, function(error) {
          $scope.loading = false;
          ScopeChangeRequest.error(error);
        });
      };

      function review(request, action, mensaje) {
        $scope.reviewing = request.id;

        ScopeChangeReview[action](request).then(function() {
          toaster.pop('success', 'Solicitud', mensaje);
          $scope.reviewing = null;
          $scope.load();
        }).catch(function(error) {
          $scope.reviewing = null;
          ScopeChangeReview.report(error, toaster);
          $scope.load();
        });
      }

      $scope.approve = function(request) {
        review(request, 'approve', 'La solicitud se aprobó y el proyecto quedó creado');
      };

      $scope.reject = function(request) {
        review(request, 'reject', 'La solicitud se rechazó correctamente');
      };

      $scope.load();
  }]);
